/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTransmissionControlList.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/transmission-control-list";

export class AutogenModelTransmissionControlList<RowType extends ModelRow> extends Endpoint<RowType, RowTransmissionControlListFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTransmissionControlList extends ModelRow<RowTransmissionControlListFields> {
	constructor(values?: Partial<RowTransmissionControlListFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTransmissionControlListFields {
	"edi_functional_grp.company_id": string;
	"edi_functional_grp.control_number": number;
	"edi_functional_grp.direction": string;
	"edi_functional_grp.edi_log_id": string;
	"edi_functional_grp.func_group_date": Date;
	"edi_functional_grp.functional_type": string;
	"edi_functional_grp.header": string;
	"edi_functional_grp.id": string;
	"edi_functional_grp.interchange_id": string;
	"edi_functional_grp.receiver_id": string;
	"edi_functional_grp.sender_id": string;
	"edi_functional_grp.sequence": number;
	"edi_functional_grp.trailer": string;
	"edi_functional_grp.version": string;
	"edi_interchange.batch": number;
	"edi_interchange.company_id": string;
	"edi_interchange.control_number": number;
	"edi_interchange.create_date": Date;
	"edi_interchange.direction": string;
	"edi_interchange.edi_tid": number;
	"edi_interchange.end_of_line": string;
	"edi_interchange.filename": string;
	"edi_interchange.header": string;
	"edi_interchange.id": string;
	"edi_interchange.intercompany": string;
	"edi_interchange.is_original": string;
	"edi_interchange.numchars": number;
	"edi_interchange.orig_profile_id": string;
	"edi_interchange.orig_trans_type": string;
	"edi_interchange.parent_document": string;
	"edi_interchange.partner_company": string;
	"edi_interchange.receiver_id": string;
	"edi_interchange.sender_id": string;
	"edi_interchange.status": string;
	"edi_interchange.status_date": Date;
	"edi_interchange.trailer": string;
	"edi_interchange.transaction_set": string;
	"edi_interchange.transaction_type": string;
	"edi_interchange.version": string;
	"edi_interchange.was_successful": string;
	"edi_log.as2_msg_id": string;
	"edi_log.batch": number;
	"edi_log.company_id": string;
	"edi_log.create_date": Date;
	"edi_log.descr": string;
	"edi_log.direction": string;
	"edi_log.directory_local": string;
	"edi_log.edi_comm_id": number;
	"edi_log.file_local_dir": string;
	"edi_log.filename": string;
	"edi_log.func_batch": number;
	"edi_log.func_receiver_id": string;
	"edi_log.func_sender_id": string;
	"edi_log.func_version": string;
	"edi_log.id": string;
	"edi_log.interchange_id": number;
	"edi_log.intercompany": string;
	"edi_log.internal_filename": string;
	"edi_log.message_id": string;
	"edi_log.message_timestamp": number;
	"edi_log.orig_profile_id": string;
	"edi_log.orig_trans_type": string;
	"edi_log.partner_company": string;
	"edi_log.receiver_id": string;
	"edi_log.sender_id": string;
	"edi_log.set_control_no": number;
	"edi_log.status": string;
	"edi_log.template_id": number;
	"edi_log.total_func_grps": number;
	"edi_log.transaction_type": string;
	"edi_log.version": string;
	"edi_log.was_successful": string;
	"edi_trans_set.company_id": string;
	"edi_trans_set.create_date": Date;
	"edi_trans_set.direction": string;
	"edi_trans_set.func_grp_ctl_no": number;
	"edi_trans_set.func_grp_sequence": number;
	"edi_trans_set.func_receiver_id": string;
	"edi_trans_set.func_sender_id": string;
	"edi_trans_set.functional_grp_dt": Date;
	"edi_trans_set.functional_grp_id": string;
	"edi_trans_set.id": string;
	"edi_trans_set.inter_receiver_id": string;
	"edi_trans_set.inter_sender_id": string;
	"edi_trans_set.interchange_ctl_no": number;
	"edi_trans_set.interchange_date": Date;
	"edi_trans_set.interchange_id": string;
	"edi_trans_set.order_id": string;
	"edi_trans_set.sequence": number;
	"edi_trans_set.set_control_no": string;
	"edi_trans_set.shipment_id": string;
	"edi_trans_set.transaction_set_id": string;
	"edi_trans_set.transaction_type": string;
	"edi_trans_set.version": string;
	"edi_trans_set.was_successful": string;
	partner_id_output: string;
	partner_name: string;
	partner_type_output: string;
	template_id_output: string;
	partner_name_input: string;
	template_id_input: string;
}

